<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XFPRlL/tc-custom/9781488004445.jpg?1728259408074" alt="This image is the cover for the book Once Upon a Regency Christmas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Once Upon a Regency Christmas
      </h1>
      <p class="bookDescription body article font2">
        <b>THREE REGENCY HEROES IN DISGUISE. </b><br/><br/><b>THREE CHRISTMAS NOVELLAS TO WARM YOUR HEART! </b><br/><br/><b>ON A WINTER'S EVE by Louise Allen </b><br/><br/>Snowbound together, Lady Julia Chalcott and Captain Giles Markham try to fight temptation. But, as Christmas draws closer, their attraction proves too strong to resist! <br/><br/><b>MARRIAGE MADE AT CHRISTMAS by Sophia James </b><br/><br/>Christine Howard's frozen heart melts as she gets to know her new bodyguard. How can a man so scarred and mysterious make her feel so safe? <br/><br/><b>CINDERELLA'S PERFECT CHRISTMAS by Annie Burrows </b><br/><br/>Shy Alice Waverly's kiss with Captain Jack Grayling makes her wonder if heand his little childrencould be the Christmas miracle she's always dreamed of
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Louise Allen, Sophia James, Annie Burrows
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?429c6a19